import { IOption } from '@vtbhome/juicyfront/types';

export const selectValue = ({ options, value }: { options: IOption[]; value: string }) => {
    const optionValues = options.filter((option) => option.value === value);
    return optionValues.filter(Boolean) as IOption[];
};
